/*检查 access_token 是否过期*/
export const CHECK_ACCESS_TOKEN = "checkAccessToken";
/*查看 access_token 权限*/
export const QUERY_PRIVILEGE = "queryPrivilege";
/*初始化权限*/
export const INIT_PRIVILEGE = "initPrivilege";
/*搜索*/
export const SEARCH = "search";
/*删除搜索热词*/
export const DEL_SEARCH_WORD = "delSearchWord";